import React, { Component } from 'react';
import { connect } from 'react-redux';

import ChatUI from './ChatUI';
import ModeratorBoard from './ModeratorBoard';
import GuestList from './GuestList';
import { getGuests } from '../actions';
import firebase from '../firebase';

const mapStateToProps = (state) => {
    return ({
        guestList: state.convo.meta.guestList
    });
}

class ModeratorScreen extends Component {
    constructor(props) {
        super(props);

        this.handleRefresh = this.handleRefresh.bind(this);
    }

    handleRefresh(event) {
        this.props.dispatch(getGuests());
    }

    render() {
        return (
            <div>
                <h1>Welcome to the moderation board!</h1>
                <GuestList guests={this.props.guestList}/> 
                <button onClick={this.handleRefresh}>Refresh guest list</button>
                <ChatUI />
                <ModeratorBoard guests={this.props.guestList} />
            </div>
        );
    }
}
export default connect(mapStateToProps)(ModeratorScreen);


// WEBPACK FOOTER //
// ./src/components/ModeratorScreen.js